import type { ISocial } from "../../../../types/models/social.models.types";
import { usePostHttp } from "../../http.hook";

interface IResponse {
  social: ISocial;
}

interface IBody {
  amount: number;
}
export function useAddToFixedPayoutAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/socials/:userId/fixed-payout",
  });
}
